import React from "react";
import { Link } from "react-router-dom";
import logo_small from "../Pages/images/logo_small";

export default function Footer() {
  return (
    <>
      {/* <!-- Start footer --> */}
      <footer
        class="footer-wrapper"
        id="particles-js-none"
        style={{
          backgroundImage: `url(https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/includes/theme-options/images/footer/Footer-Background.png)`,
        }}
      >
        <div class="footer-top pt-80 pb-80">
          <div class="container">
            <div class="row gy-5">
              <div class="col-md-6 col-lg-3 col-xl-3">
                <div
                  id="block-33"
                  class="footer-item widget_block widget_media_image"
                >
                  <figure class="wp-block-image size-large">
                    <img
                      decoding="async"
                      loading="lazy"
                      width="146"
                      height="33"
                      src={logo_small}
                      alt=""
                      class="wp-image-777"
                    />
                  </figure>
                </div>
                <div id="block-34" class="footer-item widget_block widget_text">
                  <p>
                    Top Notch Media Works is the best Branding Agency in
                    Maharashtra. We design your brand, not as Link profession
                    it’s our passion.
                  </p>
                </div>
                <div id="block-35" class="footer-item widget_block">
                  <p>
                    <form
                      id="mc4wp-form-1"
                      class="mc4wp-form mc4wp-form-778"
                      method="post"
                      data-id="778"
                      data-name="Footer one form"
                    >
                      <div class="mc4wp-form-fields">
                        <div class="footer-top">
                          <div class="footer-mail-item">
                            <div class="input-with-btn d-flex jusify-content-start align-items-strech">
                              <input
                                type="email"
                                name="EMAIL"
                                placeholder="Enter your email"
                              />
                              <button type="submit">
                                <img src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/send-icon.svg" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <input
                        type="hidden"
                        name="_mc4wp_timestamp"
                        value="1671881614"
                      />
                      <input type="hidden" name="_mc4wp_form_id" value="778" />
                      <input
                        type="hidden"
                        name="_mc4wp_form_element_id"
                        value="mc4wp-form-1"
                      />
                      <div class="mc4wp-response"></div>
                    </form>
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 col-xl-3">
                <div
                  id="nav_menu-5"
                  class="footer-item footer-two widget_nav_menu"
                >
                  <h5>Our Services</h5>
                  <div class="menu-our-services-container">
                    <ul id="menu-our-services" class="menu">
                      <li
                        id="menu-item-2270"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2270"
                      >
                        <Link to="/advertisements">Advertisements</Link>
                      </li>
                      <li
                        id="menu-item-2547"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2547"
                      >
                        <Link to="/webdesigning">Web Designing</Link>
                      </li>
                      <li
                        id="menu-item-2549"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2549"
                      >
                        <Link to="/digitalmarketing">Digital Marketing</Link>
                      </li>
                      <li
                        id="menu-item-2550"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2550"
                      >
                        <Link to="/strategicplanning">Strategic Planning</Link>
                      </li>
                      <li
                        id="menu-item-2551"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2551"
                      >
                        <Link to="/seo">SEO Optimize</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 col-xl-3">
                <div
                  id="nav_menu-6"
                  class="footer-item footer-two widget_nav_menu"
                >
                  <h5>Company</h5>
                  <div class="menu-company-container">
                    <ul id="menu-company" class="menu">
                      <li
                        id="menu-item-2059"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2059"
                      >
                        <Link to="/about">About Us</Link>
                      </li>
                      <li
                        id="menu-item-2060"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2060"
                      >
                        <Link to="/events">Events</Link>
                      </li>
                      <li
                        id="menu-item-2061"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2061"
                      >
                        <Link to="/contacts">Contact</Link>
                      </li>
                      <li
                        id="menu-item-2065"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2065"
                      >
                        <Link to="/choose">Why Choose Us</Link>
                      </li>
                      <li
                        id="menu-item-2066"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2066"
                      >
                        <Link to="/testimonials">Testimonials</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 col-xl-3">
                <div id="eg_contacts-3" class="footer-item widget_eg_contacts">
                  <div class="footer-top footer-four">
                    <h5>Contact Us</h5>
                    <div class="footer-contact-item">
                      <ul class="address-list">
                        <li>
                          <div class="address-icon">
                            <i
                              class="bi bi-geo-alt"
                              style={{ color: "rgb(230, 0, 76)" }}
                            ></i>
                          </div>
                          <Link to="#">
                            Office 212 ELDORA, Golden City Center, Behind
                            Prozone Mall, Aurangabad, Maharashtra 431001
                          </Link>
                        </li>

                        <li>
                          <div class="num-icon">
                            <i
                              class="bi bi-telephone"
                              style={{ color: "rgb(230, 0, 76)" }}
                            ></i>
                          </div>
                          <Link to="tel:+919158111116">+919158111116</Link>
                        </li>

                        <li>
                          <div class="mail-icon">
                            <i
                              class="bi bi-chat-left-text"
                              style={{ color: "rgb(230, 0, 76)" }}
                            ></i>
                          </div>
                          <a
                            href="mailto:topnotchmediaworks@gmail.com

"
                          >
                            topnotchmediaworks@gmail.com
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="container">
            <div class="row d-flex align-items-center g-3 ">
              <div class="col-lg-6 d-flex justify-content-lg-start justify-content-center justify-content-lg-start">
                <p>
                  Copyright 2022
                  <Link
                    to="https://topnotchmediaworks.com/"
                    style={{ color: "rgb(230, 0, 76)" }}
                  >
                    Topnotch Mediaworks ltd
                  </Link>
                  | Design By
                  <Link
                    to="https://topnotchmediaworks.com/"
                    style={{ color: "rgb(230, 0, 76)" }}
                  >
                    Topnotch Mediaworks ltd
                  </Link>
                </p>
              </div>
              {/* <div class="col-lg-6 d-flex justify-content-lg-end justify-content-center align-items-center">
                <ul class="f-bottom-list d-flex jusify-content-start align-items-center">
                  <li>
                    <Link target="_blank" to="#">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link target="_blank" to="#">
                      Terms of Use
                    </Link>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </footer>

      {/* <!-- End footer --> */}
    </>
  );
}
